const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/hr/case-registration/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import type { DraftCaseResponseDtoModel, RegisterDraftCaseRequestDtoModel } from '@/api/generated/models';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/hr/case-registration/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
type DraftCase = DraftCaseResponseDtoModel;

// 대상자 등록 폼 필드 (고객사 기본정보 템플릿 기준)
interface TargetFields {
  name: string;
  email: string;
  gender: 'male' | 'female' | 'etc' | '';
  birthYear: string;
  lang: 'ko' | 'en';
  phone: string;
  department: string;
  position: string;
  rank: string;
  reportingLine: string;
  teamSize: string;
  yearsAsLeader: string;
  hasLeaderExperience: boolean;
  upperLeaderName: string;
  upperLeaderEmail: string;
}
interface ReviewerRow {
  name: string;
  email: string;
  relationToReviewee: string;
  lang: 'ko' | 'en';
}

/** 행을 지우거나 순서가 바뀌어도 입력 상태가 섞이지 않도록 고정 키를 붙인다. */
type ReviewerRowState = ReviewerRow & {
  key: string;
};

/**
 * 화면 안에서만 쓰는 행 식별자. 서버로 보내지도, 저장되지도 않는다.
 * crypto.randomUUID는 보안 컨텍스트(HTTPS·localhost)에서만 있어서
 * LAN IP로 띄운 테스트 환경이나 구형 브라우저에서 깨진다. 증가 카운터면 충분하다.
 */
// 대상자 1인당 권장 리뷰어 수. 채우는 동안 진행 정도를 보여준다.
// 서버 MAX_REVIEWERS_PER_CASE 와 같은 값이어야 한다. 레포가 달라 import 로 묶을 수 없다.
/**
 * 전체 완료 시 채워져 있어야 하는 항목. 임시 저장 단계에서는 비어 있어도 된다.
 *
 * 서버 `Case.missingRequiredRegistrationFields()`와 같은 목록이어야 한다.
 * 레포지토리가 달라 import로 묶을 수 없으니 한쪽을 바꾸면 다른 쪽도 함께 고친다.
 */
/** 전체 완료 확인. 제출하면 되돌릴 수 없어, 무엇이 넘어가는지 보여주고 한 번 묻는다. */
/* ------------------------------- 폼 UI 조각 ------------------------------- */
/** 숫자 입력. 음수·소수를 막고, 포커스된 채로 스크롤하다 값이 바뀌는 사고를 방지한다. */
/** iOS 세그먼트형 선택. 항목이 적은 선택지를 드롭다운 대신 한 번에 보여준다. */
/**
 * 리뷰어 칸에서 Enter 로 폼이 제출되지 않게 막는다. 한글 IME 에서 Enter 는 조합을
 * 확정하는 키라, 이름을 치다가 무심코 전체가 저장되는 사고가 난다.
 */
/** 입력할 때마다 검색하지 않도록 잠깐 멈췄을 때만 질의어를 넘긴다. */
/**
 * 리뷰어 한 명. 성함·이메일을 치면 같은 고객사에 이미 등록된 사람을 찾아
 * 나머지 정보를 채운다. 관계는 대상자마다 달라 자동으로 채우지 않는다.
 */
/* -------------------------------- 등록 모달 -------------------------------- */
export function TSRDummyComponent() {
  return null;
}